const banks = [
  { code: "002", bank: "산업은행" },
  { code: "003", bank: "기업은행" },
  { code: "004", bank: "국민은행" },
  { code: "007", bank: "수협은행" },
  { code: "011", bank: "농협은행" },
  { code: "012", bank: "지역농축협" },
  { code: "020", bank: "우리은행" },
  { code: "023", bank: "SC제일은행" },
  { code: "027", bank: "한국씨티은행" },
  { code: "031", bank: "대구은행" },
  { code: "032", bank: "부산은행" },
  { code: "034", bank: "광주은행" },
  { code: "035", bank: "제주은행" },
  { code: "037", bank: "전북은행" },
  { code: "039", bank: "경남은행" },
  { code: "045", bank: "새마을금고연합회" },
  { code: "048", bank: "신협" },
  { code: "050", bank: "저축은행" },
  { code: "054", bank: "HSBC은행" },
  { code: "055", bank: "도이치은행" },
  { code: "057", bank: "JP모간체이스은행" },
  { code: "060", bank: "BOA은행" },
  { code: "061", bank: "BNP파리바은행" },
  { code: "062", bank: "중국공상은행" },
  { code: "064", bank: "산림조합" },
  { code: "067", bank: "중국건설은행" },
  { code: "071", bank: "우체국" },
  { code: "081", bank: "하나은행" },
  { code: "088", bank: "신한은행" },
  { code: "089", bank: "케이뱅크" },

  { code: "090", bank: "카카오뱅크" },
  { code: "092", bank: "토스뱅크" },

  // V5 내 은행들 추가
  { code: "008", bank: "수출입은행" },
  { code: "026", bank: "서울은행" },
  { code: "051", bank: "기타외국계은행" },
  { code: "052", bank: "모건스탠리은행" },
  { code: "058", bank: "미즈호은행" },
  { code: "059", bank: "엠유에프지은행" },
  { code: "063", bank: "중국은행" },
  { code: "066", bank: "교통은행" },
  { code: "076", bank: "신용보증기금" },
  { code: "077", bank: "기술보증기금" },
  { code: "101", bank: "한국신용정보원" },
  { code: "102", bank: "대신저축은행" },
  { code: "103", bank: "에스비아이저축은행" },
  { code: "104", bank: "에이치케이저축은행" },
  { code: "105", bank: "웰컴저축은행" },
  { code: "218", bank: "KB증권" },
  { code: "221", bank: "상상인증권" },
  { code: "222", bank: "한양증권" },
  { code: "223", bank: "리딩투자증권" },
  { code: "224", bank: "BNK투자증권" },
  { code: "225", bank: "IBK투자증권" },
  { code: "227", bank: "KTB투자증권" },
  { code: "230", bank: "미래에셋증권" },
  { code: "238", bank: "미래에셋대우" },
  { code: "240", bank: "삼성증권" },
  { code: "243", bank: "한국투자증권" },
  { code: "247", bank: "NH투자증권" },
  { code: "261", bank: "교보증권" },
  { code: "262", bank: "하이투자증권" },
  { code: "263", bank: "현대차증권" },
  { code: "264", bank: "키움증권" },
  { code: "265", bank: "이베스트투자증권" },
  { code: "267", bank: "대신증권" },
  { code: "269", bank: "한화투자증권" },
  { code: "270", bank: "하나금융투자" },
  { code: "278", bank: "신한금융투자" },
  { code: "279", bank: "DB금융투자" },
  { code: "280", bank: "유진투자증권" },
  { code: "287", bank: "메리츠종합금융증권" },
  { code: "288", bank: "카카오페이증권" },
  { code: "290", bank: "부국증권" },
  { code: "291", bank: "신영증권" },
  { code: "292", bank: "케이프투자증권" },
  { code: "293", bank: "한국증권금융" },
  { code: "294", bank: "한국포스증권" },
  { code: "295", bank: "우리종합금융" },
  { code: "299", bank: "아주캐피탈" },
  { code: "056", bank: "알비에스피엘씨은행" },
  { code: "209", bank: "유안타증권" },
];

let myMixin = {
  computed: {
    mobile() {
      return (
        this.$vuetify.breakpoint.name === "xs" ||
        this.$vuetify.breakpoint.name === "sm"
      );
    }
  },
  methods: {
    bankTxt(val) {
      if (val !== null && (val !== undefined ** val) !== "") {
        for (let i = 0; i < banks.length; i++) {
          if (banks[i].code === val) {
            return banks[i].bank;
          }
        }
      }
      return "";
    },

    getCodeList(codeSuperId) {
      const resultAllCodeList = this.$store.getters.getAllCodeList;

      let codeList = [];

      if (codeSuperId === "LOCALDELIVERY") {
        const localDeliveryList = resultAllCodeList.filter(
          v => v.codeSuperId === codeSuperId
        )[0].codeSuperCode;

        localDeliveryList.forEach(v => {
          codeList.push({
            id: v.id,
            address: v.address,
            deliveryCost: v.deliveryCost
          });
        });
      } else if (codeSuperId === "SHOPCATEGORY") {
        const shopCategoryList = resultAllCodeList.filter(
          v => v.codeSuperId === codeSuperId
        )[0].codeSuperCode;

        shopCategoryList.forEach(v => {
          codeList.push({
            id: v.id,
            name: v.name
          });
        });
      }

      /* 이름순으로 정렬 */
      codeList.sort(function(a, b) {
        // 오름차순
        return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
        // 광희, 명수, 재석, 형돈
      });

      return codeList;
    },

    comma(num) {
      var len, point, str;
      num = num + "";
      point = num.length % 3;
      len = num.length;
      str = num.substring(0, point);
      while (point < len) {
        if (str != "") str += ",";
        str += num.substring(point, point + 3);
        point += 3;
      }
      return str;
    }
  }
};
export default myMixin;
